import React, { Component } from "react";
import { connect } from "react-redux";
import AOS from "aos";
import { assessmentActions } from "../../../_actions";
import HeaderTransprent from "../Home/Component/HeaderTransprent";
import Footer from "../Home/Component/Footer";
import Ready from "../../../components/Ready";
import DownloadButton from "../../../components/UI/DownloadButton";
import { GiCheckMark } from "react-icons/gi";
import { FiDownload } from 'react-icons/fi';
import { Helmet } from "react-helmet";


class ResearchPaper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
    };
  }

  useEffect() {
    window.scrollTo(0, 0);
  }


  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAssessmentCartCount());
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());
    window.scrollTo(0, 0);
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
      delay: 100,
    });
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  handleSignInPage = () => {
    localStorage.removeItem("route");
    localStorage.setItem("route", this.props.history.location.pathname);
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoPage = (field) => {
    let { assessment } = this.props;
    let { userAssessmentUserProfileData } = assessment;

    if (field === "my-cart") {
      if (
        !(userAssessmentUserProfileData && userAssessmentUserProfileData.email)
      ) {
        this.props.history.push(`/assessment/` + "sign-in");
      } else {
        this.props.history.push(`/assessment/` + field);
      }
    } else {
      this.props.history.push(`/assessment/` + field);
    }
  };

  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem("route");
      localStorage.setItem("route", `/assessment/` + field);
      this.props.history.push(`/assessment/sign-in`);
    }
  };

  render() {
    let { assessment } = this.props;
    let {
      userAssessmentUserProfileData,
      getAssessmentCartCountData,
      getAssessmentPackagesShortListData,
    } = assessment;
    // let { quantity } = this.state;

    return (
      <div className="overflow-x-hidden ">

        <Helmet>
          <meta charSet="utf-8" />
          <title>How TalentPlusStrengths Helps You Unlock Potential | Process Explained</title>
          <meta name="description" content="Learn how the TalentPlusStrengths assessment identifies and develops your core strengths. Explore our process for personal and professional growth." />
          <meta name="keywords" content="Talent assessment process, how it works, strengths-based coaching, career success, leadership growth" />
          <meta name="author" content="TalentPlusStrengths" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta property="og:title" content="How TalentPlusStrengths Helps You Unlock Potential | Process Explained" />
          <meta property="og:description" content="Learn how the TalentPlusStrengths assessment identifies and develops your core strengths. Explore our process for personal and professional growth." />
          <meta property="og:image" content="https://talentplusstrengths.com/img/TalentPlusStrengths_logo.svg" />
          <meta property="og:url" content="https://talentplusstrengths.com/#/assessment/how-talentplus-strength-works" />
          <meta property="og:type" content="website" />
          <link rel="canonical" href="https://talentplusstrengths.com/#/assessment/how-talentplus-strength-works" />
        </Helmet>

        <section
          className="bg-[#2196F3]/10 w-full h-auto  bg-cover bg-no-repeat bg-right "
          style={{
            backgroundImage: `url('/img/assessment/bg-gradient.webp')`,
          }}
        >
          <HeaderTransprent
            handleSignInPage={this.handleSignInPage}
            userDetails={userAssessmentUserProfileData}
            logout={this.logout}
            gotoPage={this.gotoPage}
            cartCount={
              getAssessmentCartCountData ? getAssessmentCartCountData : 0
            }
            props2={this.props}
            prodList={getAssessmentPackagesShortListData}
            gotoMyAccount={this.gotoMyAccount}
          />
          {/* Hero Section */}
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full gap-10 md:pt-10 lg:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="flex flex-col justify-center w-full h-full pt-10 mx-auto my-auto space-y-8 text-center md:pb-10 md:pt-0 md:text-left ">
                {/* <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest ">Employer Solutions</p> */}
                <h1 data-aos="fade-right" className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold text-[#212121]  capitalize">Finding the Missing Link: The Role of Individual Accountability in Enhancing Employee Engagement for India’s Pharmaceutical Sector</h1>
                <div data-aos="fade-right" className="text-[#212121] font-normal flex flex-col gap-2 text-left">
                  <p>Bridging the gap between performance and responsibility in India's pharma workforce.</p>
                </div>
                <div className="flex flex-row items-center justify-center gap-4 md:justify-start md:items-center">
                  <DownloadButton
                    label="Download Full Research Paper"
                    width="w-full sm:w-auto"
                    bgColor="bg-[#1976D2]"
                    hoverColor="hover:bg-green-700"
                    icon={FiDownload}
                    onClick={() => console.log('Downloading...')}
                  />
                  {/* <button data-aos="fade-right"
                    onClick={() => this.gotoPage("products")}
                    className="bg-[#212121] hover:bg-[#1976D2] hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-150  text-white py-2.5 px-6 rounded uppercase cursor-pointer flex w-fit justify-center">  Book a Demo</button> */}
                </div>
              </div>

              <div className="flex items-end justify-center w-full lg:justify-end lg:pb-0 pb-10">
                <img data-aos="fade-left" src="/ResearchPaper/research-paper.webp" alt="research-paper" className="z-0 w-full" />
              </div>
            </div>
          </div>
        </section>

        {/* 2 */}
        <section className="py-16">
          <div className="flex flex-col items-center w-full gap-10 px-4 py-10 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row">
            <div className="w-full">
              <img data-aos="fade-right" src="/ResearchPaper/research-paper.webp" alt="research-paper" width={992} height={582} />
            </div>
            <div data-aos="fade-left" className="w-full space-y-6">
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]">About Research</h2>
              <p className="text-lg text-[#212121]">The word – employee engagement implies that an extent to which employees are willing to go beyond the call of duty and are emotionally invested in their work. This also suggests that such employees are willing to go above and beyond their basic job requirement. According to a research by Kahn in 1990 he defined the engagement as harnessing employees potential towards their job roles which is exhibited in various forms with doing their jobs.</p>
              <p className="text-lg text-[#212121]">High engagement is not only an indicator of employee well-being but also a driver of organizational outcomes – companies with highly engaged employees consistently report better productivity, customer satisfaction, and retention than those with disengaged workforces.</p>
              <p className="text-lg text-[#212121]">Accountability can be defined as an person’s responsibility / expectation to justify their actions and outcomes. Prior research suggests that accountability is generally associated with positive work behaviors and attitudes – for instance, higher felt accountability has been resulting to better job satisfaction and motivation for employees.</p>
            </div>
          </div>
        </section>

        <section className="pt-16">
          <div className="flex flex-col items-center w-full gap-10 px-4 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row">
            <div className="textblack border-b border-[#D9D9D9]">
              <h2 class="text-3xl font-semibold mb-6">Key Insights:</h2>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
                <div class="flex items-start space-x-3 border-r border-[#D9D9D9] pr-5">
                  <GiCheckMark size={20} className="textcolor mt-1.5" />
                  <p class="text-lg">Accountability improved team productivity by <span class="textcolor font-medium">30%</span>.</p>
                </div>
                <div class="flex items-start space-x-3 border-r border-[#D9D9D9] pr-4">
                  <GiCheckMark size={20} className="textcolor mt-1.5" />
                  <p class="text-lg">Lack of <span class="textcolor font-medium">Role Clarity</span> weakened engagement levels.</p>
                </div>
                <div class="flex items-start space-x-3">
                  <GiCheckMark size={20} className="textcolor mt-1.5" />
                  <p class="text-lg">Frontline managers play a key role in <span class="textcolor font-medium">Ownership Culture</span>.</p>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className="pb-16">
          <div className="flex flex-col items-center w-full gap-10 px-4 py-10 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row">
            <div>
              <h2 class="text-3xl font-semibold mb-6">Authors</h2>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div class="author-card px-8 py-12 rounded-xl text-center bg-[#F9FAFB]">
                  <div class="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                    <img src="/ResearchPaper/Ms.-Shyamasree-Chakrabarty.webp" alt="Ms. Shyamasree Chakrabarty" class="w-full h-full object-cover" />
                  </div>
                  <h3 class="text-xl font-semibold mb-1">Ms. Shyamasree Chakrabarty</h3>
                  <p class="text-sm text-gray-600">Research Scholar, School of Management & Commerce, Manav Rachna University, Faridabad</p>
                </div>
                <div class="author-card px-8 py-12 rounded-xl text-center bg-[#F9FAFB]">
                  <div class="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                    <img src="/ResearchPaper/Dr.-Pragati-Chauhan.webp" alt="Dr. Pragati Chauhan" class="w-full h-full object-cover" />
                  </div>
                  <h3 class="text-xl font-semibold mb-1">Dr. Pragati Chauhan</h3>
                  <p class="text-sm text-gray-600">Professor, School of Management & Commerce, Manav Rachna University, Faridabad</p>
                </div>
                <div class="author-card px-8 py-12 rounded-xl text-center bg-[#F9FAFB]">
                  <div class="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                    <img src="/ResearchPaper/Ashish-Ambasta.webp" alt="Dr. Ashish Ambasta" class="w-full h-full object-cover" />
                  </div>
                  <h3 class="text-xl font-semibold mb-1">Dr. Ashish Ambasta</h3>
                  <p class="text-sm text-gray-600">CEO, HappyPlus Consulting</p>
                </div>
              </div>
              <div class="flex justify-center mt-12">
                <DownloadButton
                  label="Download Full Research Paper"
                  width="w-full sm:w-auto"
                  bgColor="bg-[#1976D2]"
                  hoverColor="hover:bg-green-700"
                  icon={FiDownload}
                  onClick={() => console.log('Downloading...')}
                />
              </div>
            </div>
          </div>
        </section>

        <Ready />
        <Footer
          props2={this.props}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />
      </div>
    );
  }
}

ResearchPaper.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(ResearchPaper);
